import { render, staticRenderFns } from "./AccountActivityView.vue?vue&type=template&id=889b24f8&scoped=true"
import script from "./AccountActivityView.vue?vue&type=script&lang=js"
export * from "./AccountActivityView.vue?vue&type=script&lang=js"
import style0 from "./AccountActivityView.vue?vue&type=style&index=0&id=889b24f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889b24f8",
  null
  
)

export default component.exports